import React from "react";
import PropTypes from "prop-types";
import brand from "@/theme/brand";

const Logo = props => (
  <img alt={`${brand.name} logo`} src={props.withName ? brand.logoFullUrl : brand.logoResponsiveUrl}
    onClick={props.onClick}
    className={props.className}
    style={{
      cursor: props.onClick ? "pointer" : "inherit",
      height: props.size,
      textAlign: "center",
      ...props.style
    }}
  />
);

Logo.propTypes = {
  withName: PropTypes.bool,
  color: PropTypes.string
};

Logo.defaultProps = {
  color: "black"
};

export default Logo;
